import type { RefObject } from 'react';
import { useParallax } from './useParallax';

/** Component form of {@link useParallax}, for the shell (rendered inside the page's Suspense boundary). */
export function ParallaxArm({
  scope,
  pageKey,
}: {
  readonly scope: RefObject<HTMLElement | null>;
  readonly pageKey: string;
}): null {
  useParallax(scope, pageKey);
  return null;
}
